import ACLStore from "lib/aclStore";

const getCurriculumIdsFilterForTags = ({
  curriculumProgramId,
  isMutation = false,
}) => {
  const isTagsMovedToCurriculum = ACLStore.can(
    "FeatureFlag:MoveTagToCurriculum"
  );
  if (!isTagsMovedToCurriculum || !curriculumProgramId) return {};

  if (isMutation) {
    return { curriculumProgramId };
  }
  return { curriculumProgramIds: [curriculumProgramId] };
};

export default getCurriculumIdsFilterForTags;
